// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyTipTapTextEditor_main__08Yd9 .ProseMirror {
    width: 100%;
    height: 200px;
    border: 1px solid #ccc;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.MyTipTapTextEditor_main__08Yd9 .ProseMirror::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror::-webkit-scrollbar-thumb:hover {/*滚动条里面小方块*/
    background: #e3e3e3;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror > * + * {
    margin-top: 0.75em;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror ul,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror ol {
    padding: 0 1rem;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror h1,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror h2,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror h3,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror h4,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror h5,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror h6 {
    line-height: 1.1;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror img {
    max-width: 90%;
    height: auto;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(13, 13, 13, 0.1);
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror hr {
    border: none;
    border-top: 2px solid rgba(13, 13, 13, 0.1);
    margin: 2rem 0;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror strong,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror b {
    font-weight: bold;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror em,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror i {
    font-style: italic;
}

/* 确保编辑器中各层级标题样式正确 */
.MyTipTapTextEditor_main__08Yd9 .ProseMirror h1 {
    font-size: 2rem;
    font-weight: bold;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror h2 {
    font-size: 1.75rem;
    font-weight: bold;
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror h3 {
    font-size: 1.5rem;
    font-weight: bold;
}

/* 无序列表 */
.MyTipTapTextEditor_main__08Yd9 .ProseMirror ul {
    list-style-type: disc;  /* 圆点符号 */
    padding-left: 20px;     /* 左边距 */
}

.MyTipTapTextEditor_main__08Yd9 .ProseMirror li {
    margin-bottom: 5px;     /* 列表项之间的间距 */
}

/* 有序列表 */
.MyTipTapTextEditor_main__08Yd9 .ProseMirror ol {
    list-style-type: decimal; /* 数字样式 */
    padding-left: 20px;       /* 左边距 */
}

/* 列表项 */
.MyTipTapTextEditor_main__08Yd9 .ProseMirror li {
    margin-bottom: 5px;
}

/* 列表项缩进 */
.MyTipTapTextEditor_main__08Yd9 .ProseMirror li > ul,
.MyTipTapTextEditor_main__08Yd9 .ProseMirror li > ol {
    margin-left: 20px;  /* 增加缩进 */
}

/* custom */
.MyTipTapTextEditor_is_active__iILV4 {
    background-color: #000;
    color: #fff;
}

.MyTipTapTextEditor_menu_toolbar__DZgNw {
    padding: 5px;
    border: 1px solid #ccc;
    border-bottom: none;
}

.MyTipTapTextEditor_menu_toolbar__DZgNw button {
    padding: 5px;
    font-size: 16px;
    cursor: pointer;
}

.MyTipTapTextEditor_editor__GYMCq {
    border: 1px solid #ccc;
    padding: 10px;
    min-height: 300px;
    background-color: #fff;
}

.MyTipTapTextEditor_custom_btn__G2GNg {
    display: inline-block;
    padding: 10px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    border-radius: 2px;
    transition: all 0.3s ease;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.MyTipTapTextEditor_custom_btn__G2GNg:hover,
.MyTipTapTextEditor_custom_btn_active__Ahm7j {
    border: 1px solid #3f96ff;
    color: #3f96ff;
}

.MyTipTapTextEditor_menu_toolbar__DZgNw .MyTipTapTextEditor_menu_upload_status__AI-uy {
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/common/MyTipTapTextEditor/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,iEAAgD,UAAU;IACtD,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA,uEAAsD,WAAW;IAC7D,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA,6EAA4D,WAAW;IACnE,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;;;;IAMI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,SAAS;AACT;IACI,qBAAqB,GAAG,SAAS;IACjC,kBAAkB,MAAM,QAAQ;AACpC;;AAEA;IACI,kBAAkB,MAAM,aAAa;AACzC;;AAEA,SAAS;AACT;IACI,wBAAwB,EAAE,SAAS;IACnC,kBAAkB,QAAQ,QAAQ;AACtC;;AAEA,QAAQ;AACR;IACI,kBAAkB;AACtB;;AAEA,UAAU;AACV;;IAEI,iBAAiB,GAAG,SAAS;AACjC;;AAEA,WAAW;AACX;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".main :global(.ProseMirror) {\n    width: 100%;\n    height: 200px;\n    border: 1px solid #ccc;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.main :global(.ProseMirror::-webkit-scrollbar) {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n}\n\n.main :global(.ProseMirror::-webkit-scrollbar-thumb) {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.main :global(.ProseMirror::-webkit-scrollbar-thumb:hover) {/*滚动条里面小方块*/\n    background: #e3e3e3;\n}\n\n.main :global(.ProseMirror > * + *) {\n    margin-top: 0.75em;\n}\n\n.main :global(.ProseMirror ul),\n.main :global(.ProseMirror ol) {\n    padding: 0 1rem;\n}\n\n.main :global(.ProseMirror h1),\n.main :global(.ProseMirror h2),\n.main :global(.ProseMirror h3),\n.main :global(.ProseMirror h4),\n.main :global(.ProseMirror h5),\n.main :global(.ProseMirror h6) {\n    line-height: 1.1;\n}\n\n.main :global(.ProseMirror img) {\n    max-width: 90%;\n    height: auto;\n}\n\n.main :global(.ProseMirror blockquote) {\n    padding-left: 1rem;\n    border-left: 2px solid rgba(13, 13, 13, 0.1);\n}\n\n.main :global(.ProseMirror hr) {\n    border: none;\n    border-top: 2px solid rgba(13, 13, 13, 0.1);\n    margin: 2rem 0;\n}\n\n.main :global(.ProseMirror strong),\n.main :global(.ProseMirror b) {\n    font-weight: bold;\n}\n\n.main :global(.ProseMirror em),\n.main :global(.ProseMirror i) {\n    font-style: italic;\n}\n\n/* 确保编辑器中各层级标题样式正确 */\n.main :global(.ProseMirror h1) {\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.main :global(.ProseMirror h2) {\n    font-size: 1.75rem;\n    font-weight: bold;\n}\n\n.main :global(.ProseMirror h3) {\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n/* 无序列表 */\n.main :global(.ProseMirror ul) {\n    list-style-type: disc;  /* 圆点符号 */\n    padding-left: 20px;     /* 左边距 */\n}\n\n.main :global(.ProseMirror li) {\n    margin-bottom: 5px;     /* 列表项之间的间距 */\n}\n\n/* 有序列表 */\n.main :global(.ProseMirror ol) {\n    list-style-type: decimal; /* 数字样式 */\n    padding-left: 20px;       /* 左边距 */\n}\n\n/* 列表项 */\n.main :global(.ProseMirror li) {\n    margin-bottom: 5px;\n}\n\n/* 列表项缩进 */\n.main :global(.ProseMirror li > ul),\n.main :global(.ProseMirror li > ol) {\n    margin-left: 20px;  /* 增加缩进 */\n}\n\n/* custom */\n.is_active {\n    background-color: #000;\n    color: #fff;\n}\n\n.menu_toolbar {\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-bottom: none;\n}\n\n.menu_toolbar button {\n    padding: 5px;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.editor {\n    border: 1px solid #ccc;\n    padding: 10px;\n    min-height: 300px;\n    background-color: #fff;\n}\n\n.custom_btn {\n    display: inline-block;\n    padding: 10px;\n    border: 1px solid #d9d9d9;\n    background-color: #fff;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    user-select: none;\n}\n\n.custom_btn:hover,\n.custom_btn_active {\n    border: 1px solid #3f96ff;\n    color: #3f96ff;\n}\n\n.menu_toolbar .menu_upload_status {\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `MyTipTapTextEditor_main__08Yd9`,
	"is_active": `MyTipTapTextEditor_is_active__iILV4`,
	"menu_toolbar": `MyTipTapTextEditor_menu_toolbar__DZgNw`,
	"editor": `MyTipTapTextEditor_editor__GYMCq`,
	"custom_btn": `MyTipTapTextEditor_custom_btn__G2GNg`,
	"custom_btn_active": `MyTipTapTextEditor_custom_btn_active__Ahm7j`,
	"menu_upload_status": `MyTipTapTextEditor_menu_upload_status__AI-uy`
};
export default ___CSS_LOADER_EXPORT___;
